export const baseUrl = process.env.REACT_APP_BASE_URL;
// export const baseUrl = "http://192.168.2.120:8000/";
// export const baseUrl = "https://api.atmanirbharfins.com/";

// User
export const userUrl = baseUrl + "api/user/";
export const userRefreshUrl = userUrl + "auth/refresh";
export const getUserProfileUrl = userUrl + "user-profile";

// Auth
export const loginUrl = userUrl + "auth/login";
export const relationshipManagerLoginUrl = baseUrl + "api/relationship-manager/login";

// Common
export const commonUrl = baseUrl + "api/common";

// Company
export const getAllCompaniesUrl = baseUrl + "api/company/company-list";
export const createCompanyUrl = baseUrl + "api/company/create-company";

// Category
export const getAllCategoriesUrl = baseUrl + "api/category";
export const addAllCategoriesUrl = baseUrl + "api/category";
export const getSubCategoriesByIdUrl = baseUrl + "api/sub-category/get-sub-categories-by-category";
export const addSubCategories = baseUrl + "api/sub-category/";
export const getCategoriesWithSubCategoriesUrl = baseUrl + "api/category/get-categories-with-sub-categories";
export const getAllSubCategoriesUrl = baseUrl + "api/sub-category/get-all-sub-categories";
export const getAllCategoriesWithProductCountUrl = baseUrl + "api/category/get-categories-with-product-count";
export const updateCategorySortOrderUrl = baseUrl + "api/category/update-sort-order";
export const updateProductSortOrderUrl = baseUrl + "api/product/update-sort-order";

// regions
export const getAllStatesUrl = baseUrl + "api/state";
export const getCompanyRegionsUrl = baseUrl + "api/region";
export const addRegionUrl = baseUrl + "api/region/add-region";
export const getRegionsList = baseUrl + "api/region/get-region-list-by-company-id"
export const deleteRegionUrl = baseUrl + "api/region/delete-region"
export const updateRegion = baseUrl + "api/region/update-region"
export const checkRegion = baseUrl + "api/region/check-region"
export const checkRM = baseUrl + "api/relationship-manager/check-relationship-manager"






//Products
export const addProductUrl = baseUrl + "api/product/add-product";
export const allProductUrl = baseUrl + "api/product/get-products-by-category-id";
export const deleteProductUrl = baseUrl + "api/product/delete-product";
export const updateProductUrl = baseUrl + "api/product/update-product";
export const getProductListByCompanyIdUrl = (companyId) => baseUrl + `api/product/get-product-list-by-company-id/${companyId}`;



//Relationship manager
export const addRMUrl = baseUrl + "api/relationship-manager/add-relationship-manager";
export const assignRMToLead = baseUrl + "api/relationship-manager/assign-relationship-manager-to-lead"
export const allRM = baseUrl + "api/lead/lead-list";
export const getRMList = baseUrl + "api/relationship-manager/get-relationship-manager-list-by-company-id"
export const deleteRM = baseUrl + "api/relationship-manager/delete-relationship-manager"
export const updateRMUrl = baseUrl + "api/relationship-manager/update-relationship-manager"
export const sendWhatsAppOtpToRm = baseUrl + "api/relationship-manager/relationship-manager-mobile-send-otp"
export const verifyWhatsAppOtpForRM = baseUrl + "api/relationship-manager/relationship-manager-mobile-verify"
export const makeCredentialsRmUrl = baseUrl + "api/relationship-manager/make-credentials-relationship-manager"
export const getCategoryListForRelationshipManagerUrl = baseUrl + "api/relationship-manager/get-category-list-for-relationship-manager"


//Leads
export const leadStatsUrl = baseUrl + "api/lead/lead-statistics-number";
export const allLeadsUrl = baseUrl + "api/lead/lead-list";
export const getLeadDetailsUrl = baseUrl + "api/lead/lead-details-by-lpr-id"


// Advisors
export const allApprovedAdvisors = baseUrl + "api/advisor/advisor-list";

export const remenurationCompanyFinanceUrl= baseUrl+"api/remuneration/get-remuneration-company-with-financial-statistics"
export const advisorleadDataUrl=baseUrl+"api/lead/lead-list-product-by-advisor-id"

//config
export const getmobileBannerConfig = baseUrl + "api/config/mobile-banner/get-config?is_active=true"
export const postmobileBannerConfig = baseUrl + "api/config/mobile-banner/insert-config"
export const leadCompanyUrl = baseUrl + "api/company/get-converted-lead-list-by-company-id"
export const deleteBanner = baseUrl + "api/config/mobile-banner/delete-config/{id}";
export const updateTermsAndCondition = baseUrl + "api/common/update-term-and-condition";
export const getTermsAndConditions = baseUrl + "api/common/get-term-and-condition";
export const getHelpCenter = baseUrl + "api/common/get-help-center";
export const updateHelpCenter = baseUrl + "api/common/update-help-center"

//LMS
export const createNewCourse = baseUrl + "api/course/create-course";
export const createCourseModule = baseUrl + "api/course/add-course-module"
export const getCourseList = baseUrl + "api/course/course-list";
export const getAllCourseModules = baseUrl + "api/course/course-module-list/{course_id}";
export const deleteCourse = baseUrl + "api/course/delete-course";
export const updateCourse = baseUrl + "api/course/update-course";
export const updateCourseModule = baseUrl + "api/course/update-course-module";
export const getCourseDetails = baseUrl + "api/course/course-details/{id}"



// Remuneration
export const insertExcelDataForBeforeIssuanceUrl = baseUrl + 'api/issuance/before-issuance/insert-excel-data'
export const insertExcelDataForAfterIssuanceUrl = baseUrl + 'api/issuance/after-issuance/insert-excel-data'
export const getInvoiceListForAdmin = baseUrl + "api/remuneration/get-remuneration-invoice-list-for-admin"
export const getremunerationPaymentList = baseUrl + "api/remuneration/get-remuneration-payment-list";
export const getInvoiceDetails = (invoice_display_id) => `${baseUrl}api/remuneration/get-invoice-details-by-display-id/${invoice_display_id}`;


// Scheduler config 
export const AddSchedularConfig = baseUrl + "api/config/invoice-scheduler/insert-config"
export const UpdateSchedularConfig = baseUrl + "api/config/invoice-scheduler/update-config"
export const DeleteSchedularConfig = baseUrl + "api/config/invoice-scheduler/delete-config"
export const GetSchedularConfig = baseUrl + "api/config/invoice-scheduler/get-config"

// Invoice Config
export const AddInvoiceTemplate = baseUrl + "api/config/invoice-config/invoice-template-generation"
export const UpdateInvoiceTemplate = baseUrl + "api/config/invoice-config/update-invoice-template-generation"
export const GetInvoiceTemplates = baseUrl + "api/config/invoice-config/get-invoice-template-generation"
export const UpdateInvoiceTemplateLogo = baseUrl + "api/config/invoice-config/upload-invoice-template-generation-logo"
// export const GetInvoiceTemplate = baseUrl + "view/invoice/get-invoice-view/{invoice_display_id}"

//Invoice
export const viewInvoiceDocument = (invoice_display_id) => `${baseUrl}view/invoice/get-invoice-view/${invoice_display_id}`;


//   Issuance
export const getExcelDataForBeforeIssuanceUrl = baseUrl + "api/issuance/before-issuance/get-excel-data-for-before-issuance"
export const getExcelDataForAfterIssuanceUrl = baseUrl + "api/issuance/after-issuance/get-excel-data-for-after-issuance"

export const getAllExcelData = baseUrl + "api/issuance/after-issuance/get-excel-data-for-after-issuance"

export const getBankMisExcelDataUrl = baseUrl + "api/issuance/bank-mis/get-excel-data-for-bank-mis-download"

// Notifications
export const getNotificationTriggerListUrl = baseUrl + "api/notification/get-notification-trigger-list";
export const getNotificationTriggerMessagesUrl = baseUrl + "api/notification/get-notification-trigger-messages";
export const addNotificationTriggerMessagesUrl = baseUrl + "api/notification/add-notification-trigger-messages";
export const updateNotificationTriggerMessagesUrl = baseUrl + "api/notification/update-notification-trigger-messages";
export const deleteNotificationTriggerMessagesUrl = baseUrl + "api/notification/delete-notification-trigger-messages";


// Become Advisor
export const getBecomeAdvisor = baseUrl + "api/common/get-become-advisor"

//* Support Chat (agent side)
export const getSupportConversationsUrl = baseUrl + "api/support/conversations";
export const getSupportMessagesUrl = (conversationId) =>
  baseUrl + `api/support/conversation/${conversationId}/messages`;
export const sendSupportMessageUrl = baseUrl + "api/support/message";
export const markSupportReadUrl = (conversationId) =>
  baseUrl + `api/support/conversation/${conversationId}/read`;
export const assignSupportConversationUrl = (conversationId) =>
  baseUrl + `api/support/conversation/${conversationId}/assign`;
export const setSupportStatusUrl = (conversationId) =>
  baseUrl + `api/support/conversation/${conversationId}/status`;

//* Subscription plans (note: backend mount path is "subscrpition")
export const createPlanUrl = baseUrl + "api/subscrpition/subscription";
export const getPlansListUrl = baseUrl + "api/subscrpition/subscriptions";
export const getAllAdvisorSubscriptionsUrl = baseUrl + "api/payment/all-subscriptions";

//* Certification (admin)
export const createExamUrl = baseUrl + "api/certification/exam";
export const updateExamUrl = (id) => baseUrl + `api/certification/exam/${id}`;
export const deleteExamUrl = (id) => baseUrl + `api/certification/exam/${id}`;
export const getExamFullUrl = (id) => baseUrl + `api/certification/exam/${id}/full`;
export const addExamQuestionUrl = (id) => baseUrl + `api/certification/exam/${id}/question`;
export const listExamsAdminUrl = baseUrl + "api/certification/exams";

//* Referral (admin)
export const getAllReferralsUrl = baseUrl + "api/referral/all";
export const markReferralConvertedUrl = baseUrl + "api/referral/mark-converted";

//* Journeys (drip campaigns — admin)
export const listJourneysUrl = baseUrl + "api/journey/admin/list";
export const toggleJourneyUrl = (id) => baseUrl + `api/journey/admin/${id}/toggle`;
export const updateJourneyStepUrl = (stepId) => baseUrl + `api/journey/admin/step/${stepId}`;

//* Lead Engagement (admin servicing)
export const pipelineStatsUrl = baseUrl + "api/lead-engagement/admin/pipeline-stats";
export const activationFunnelUrl = baseUrl + "api/lead-engagement/admin/activation-funnel";
export const rmPerformanceUrl = baseUrl + "api/lead-engagement/admin/rm-performance";
export const leadStatusesUrl = baseUrl + "api/lead-engagement/statuses";
export const leadStageUrl = (lprId) => baseUrl + `api/lead-engagement/${lprId}/stage`;
export const leadNoteUrl = (lprId) => baseUrl + `api/lead-engagement/${lprId}/note`;
export const leadTimelineUrl = (lprId) => baseUrl + `api/lead-engagement/${lprId}/timeline`;
export const leadTasksForLeadUrl = (lprId) => baseUrl + `api/lead-engagement/${lprId}/tasks`;
